import React from 'react';

export default (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" {...props}>
    <g fill="none" fillRule="nonzero" stroke="var(--color-primary)" transform="rotate(45 19 19)">
      <path d="M19 0v38M0 19h38" />
    </g>
  </svg>
);
